import React from 'react';
import { Col } from '@gjensidige/core-grid';

import './Enquiry.scss';
import { IEnquiryProps } from '../../interfaces/EnquiryInterface';
import InformationHeader from '../Common/InformationHeader/InformationHeader';
import { EnquiryHeader } from './EnquiryHeader';
import { EnquiryOptions } from './EnquiryOptions';
import { Alert, Title } from '@gjensidige/builders-components';
import { EnquiryAlert } from './EnquiryAlert';

export const Enquiry: React.FC<IEnquiryProps> = (props: IEnquiryProps) => {
  const renderHeader = () => {
    if (props.data?.controlType === 'Information') {
      return (
        <InformationHeader
          title={props.data?.header}
          informationText={props.data?.question}
          infoLink={props.data?.infoLink}
          alignCenter={props.alignCenter}
          mainHeader={props.mainHeader}
          headerAs={props.data?.headerAs}
        />
      );
    } else if (props.data?.controlType !== 'Alert') {
      return (
        <EnquiryHeader
          questionNumber={props.data?.sequence}
          questionHeader={props.data.header}
          wrapWithColumn={props.stepCode === '002'}
        />
      );
    }
  };

  const renderAlert = () => {
    if (props.data?.controlType === 'Alert') {
      return (
        <EnquiryAlert
          header={props.data.header}
          question={props.data.question}
          isVisible={props.data.isVisible}
          isEnabled={props.data.isEnabled}
          questionKey={props.data.questionKey}
          conditions={props.data?.conditions}/>
      );
    }
  };

  const renderQuestions = () => {
    if (props.data?.options) {
      return props.stepCode === '002' ? (
        <Col
          sm="12"
          md="12"
          lg={{ span: 9, offset: 2 }}
          xl={{ span: 9, offset: 2 }}
        >
          <EnquiryOptions
            inputType={props.data.controlType}
            options={props.data.options}
            selectedValue={props.data.selectedValue}
            placeholderText={props.data.placeholderText}
            questionType={props.data.APIKey ? props.data.APIKey : ''}
            handleChange={props.handleChange}
            moreInformation={props.data.infoLink}
            alignCenter={props.alignCenter}
            isVertical={props.isVertical}
            isValid={props.data.isValid}
            isDisabled={props.data.isDisabled}
            isImmutable={props.data.isImmutable}
            errorMessage={props.data.errorMessage}
            isNumeric={!!props.data.isNumeric}
            labelText={props.data.question}
            labelDescription={props.data.questionDescription}
            postfixText={props.data.postfixText || ''}
            isMarginTop={props.isMarginTop}
            isChecked={props.data.isChecked}
            checkboxText={props.data.checkboxText}
            terms={props.data.terms}
          />
        </Col>
      ) : (
        <div>
          <EnquiryOptions
            inputType={props.data.controlType}
            options={props.data.options}
            selectedValue={props.data.selectedValue}
            placeholderText={props.data.placeholderText}
            questionType={props.data.APIKey ? props.data.APIKey : ''}
            handleChange={props.handleChange}
            moreInformation={props.data.infoLink}
            alignCenter={props.alignCenter}
            isVertical={props.isVertical}
            helpText={props.data.helpText}
            disabledHelpText={props.data.disabledHelpText}
            labelText={props.data.question}
            labelDescription={props.data.questionDescription}
            isValid={props.data.isValid}
            isNumeric={!!props.data.isNumeric}
            postfixText={props.data.postfixText || ''}
            errorMessage={props.data.errorMessage}
            isDisabled={props.data.isDisabled}
            isImmutable={props.data.isImmutable}
            isMarginTop={props.isMarginTop}
            isChecked={props.data.isChecked}
            checkboxText={props.data.checkboxText}
            terms={props.data.terms}
          />
        </div>
      );
    }
    return '';
  };

  return (
    <>
      {renderHeader()}
      {renderQuestions()}
      {renderAlert()}
    </>
  );
};
